import { BottomSheetDialog } from "@foodpilot/foods";
import type { ComponentProps, ComponentType, ReactNode } from "react";

type FoodsBottomSheetDialogProps = Omit<ComponentProps<typeof BottomSheetDialog>, "content" | "title"> & {
    content: ReactNode;
    title: ReactNode;
};

/** Corrects the published FOODS intersection type while keeping its runtime component unchanged. */
export const FoodsBottomSheetDialog = BottomSheetDialog as unknown as ComponentType<FoodsBottomSheetDialogProps>;
